import { GravityForm } from "@components/form/GravityForm2"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { useGravityForm } from "eddev/integrations/gravityforms"

export const meta: BlockMeta = {
  title: "Form",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/form", (props) => {
  return (
    <div className="w-grid mx-auto my-10">
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-10 py-7">
        <div className="w-full">
          <EditableText
            as="p"
            store="subtitle"
            className="type-label-s-caps"
            placeholder="Enter an optional subtitle"
          />
          <EditableText as="h2" store="title" className="mt-4 type-title-m text-balance" placeholder="Enter a title" />
          <div className="w-full flex flex-col gap-4 mt-5 [&_p]:!w-full [&_p]:!mt-0 [&_p]:!px-0 [&_.wysiwyg-text]:!px-0 [&_.wysiwyg-text]:!w-full [&_.wysiwyg-text]:!mt-0 [&_ul]:!gap-2 [&_ol]:!gap-2 [&_li]:!ml-4">
            <InnerBlocks
              allowedBlocks={["#inline", "content/buttons"]}
              template={[["core/paragraph", { placeholder: "Enter some text" }]]}
              orientation="vertical"
              adminClassName="w-full flex flex-col gap-4"
            />
          </div>
        </div>
        <div className="w-full">
          {!!props.form && <GravityForm form={props.form} />}
          {!props.form && env.admin && (
            <div className="w-full aspect-video rounded-lg bg-grey p-7 flex items-center justify-center type-label-m">
              Select a form
            </div>
          )}
        </div>
      </div>
    </div>
  )
})
